import { EXPLORE_ROUTES } from './explore-search';
import type { ExploreApiPrefix } from './competitor-filter-defaults';

const DEFAULT_EXPLORE_PREFIX: ExploreApiPrefix = '/dashboard';

export type ExploreDataScope = 'dashboard' | 'overview' | 'drilldown';

export function exploreApiPrefix(pathname: string): ExploreApiPrefix {
  if (pathname.startsWith('/overview')) return '/overview';
  if (pathname.startsWith('/drilldown')) return '/drilldown';
  if (pathname.startsWith('/dashboard')) return '/dashboard';
  for (const route of EXPLORE_ROUTES) {
    if (pathname.startsWith(route)) {
      if (route === '/overview') return '/overview';
      if (route === '/drilldown') return '/drilldown';
      return '/dashboard';
    }
  }
  return DEFAULT_EXPLORE_PREFIX;
}

/** Maps the active explore route to the domain-scoped data API prefix. */
export function exploreDataScope(pathname: string): ExploreDataScope {
  const prefix = exploreApiPrefix(pathname);
  if (prefix === '/overview') return 'overview';
  if (prefix === '/drilldown') return 'drilldown';
  return 'dashboard';
}
